import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionMultipleChoiceAnswerSchema = z
  .object({
    id: z.string(),
    correct: z.boolean(),
    explanation: z.string().optional(),
    content: z.string().min(1, 'Opis jest wymagany').max(512),
    points: z.number().positive('Punkty muszą być liczbą dodatnią').optional(),
  })
  .refine((data) => !data.correct || (typeof data.points === 'number' && data.points > 0), {
    path: ['points'],
    message: 'Wprowadź punkty za poprawną odpowiedź',
  });

export const questionMultipleChoiceSchema = questionBaseSchema.extend({
  type: z.literal(QuestionType.MULTIPLE),
  answers: z.array(questionMultipleChoiceAnswerSchema).min(2, 'Minimum 2 odpowiedzi').max(5, 'Maksimum 5 odpowiedzi'),
});

export type QuestionMultipleChoiceSchema = Infer<typeof questionMultipleChoiceSchema>;

export type QuestionMultipleChoiceAnswerSchema = Infer<typeof questionMultipleChoiceAnswerSchema>;
